// Metric definitions (§10) — pure functions, same code path for top KPIs and drilled sub-slices

export const attainment = (closedWon, quota) => (quota ? closedWon / quota : 0);

export const pipelineCoverage = (openPipeline, quota) => (quota ? openPipeline / quota : 0);

export const ltv = (arpa, grossMarginPct, annualChurnPct) =>
  annualChurnPct ? (arpa * (grossMarginPct / 100)) / (annualChurnPct / 100) : 0;

export const ltvCac = (ltvVal, cac) => (cac ? ltvVal / cac : 0);

export const cacPaybackMonths = (cac, arpa, grossMarginPct) => {
  const annualGm = arpa * (grossMarginPct / 100);
  return annualGm ? (cac / annualGm) * 12 : 0;
};

export const nrr = (churnPct, expansionPct) => 100 - churnPct + expansionPct;

export const grr = (churnPct) => 100 - churnPct;

export const ruleOf40 = (revGrowthPct, operatingMarginPct) => revGrowthPct + operatingMarginPct;

export const magicNumber = (netNewArr, priorSm) => (priorSm ? netNewArr / priorSm : 0);

export const burnMultiple = (opex, revenue, netNewArr, smSpend) => {
  if (!netNewArr) return 0;
  const netBurn = opex - revenue;
  return netBurn > 0 ? netBurn / netNewArr : smSpend / netNewArr;
};

export const arrBridge = (openingARR, movements) => {
  const sum = (t) => movements.filter((m) => m.type === t).reduce((s, m) => s + m.amount, 0);
  const newArr = sum("new");
  const expansion = sum("expansion");
  const contraction = sum("contraction"); // negative
  const churn = sum("churn"); // negative
  return { openingARR, newArr, expansion, contraction, churn, endingARR: openingARR + newArr + expansion + contraction + churn };
};

export const stepConversion = (stages) =>
  stages.map((s, i) => ({ ...s, conversion: i === 0 ? 1 : stages[i - 1].count ? s.count / stages[i - 1].count : 0 }));
